import { render, staticRenderFns } from "./cdsCustomizeInvitation.vue?vue&type=template&id=97be6b44&scoped=true"
import script from "./cdsCustomizeInvitation.vue?vue&type=script&lang=js"
export * from "./cdsCustomizeInvitation.vue?vue&type=script&lang=js"
import style0 from "./cdsCustomizeInvitation.vue?vue&type=style&index=0&id=97be6b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97be6b44",
  null
  
)

export default component.exports